import { View } from 'react-native';
import { Breeder, MediaAsset } from 'shared/@types';
import { AdBanner } from 'shared/components/ad-banner';
import { AdAnimalProvider } from 'shared/components/ad-banner/ad-animal-context';
import { BreederProfileHeader } from 'shared/components/breeder-profile-header';
import { PageContent } from 'shared/components/page-content';

interface BreederProfilePageProps {
  breeder: Breeder;
  mediaAssets?: MediaAsset[];
  children: React.ReactNode;
}

export function BreederProfilePage({ breeder, mediaAssets, children }: BreederProfilePageProps) {
  return (
    <AdAnimalProvider animal={breeder.animal}>
      <PageContent className={'!py-0'} contentClassName={'max-w-screen-xl'}>
        <AdBanner className={'mt-4 md:mt-6'} placement={'top'} />
        <BreederProfileHeader breeder={breeder} mediaAssets={mediaAssets} />
        <View className={'mt-4 pb-8 md:mt-5 md:pb-12'}>{children}</View>
      </PageContent>
    </AdAnimalProvider>
  );
}
